var exports = {
  "q": "xfd349460--93bcc6--badge",
  "h": "xfd349460--93bcc6--description",
};

module.exports = exports;
